import React from "react";
import { PropTypes } from "prop-types";
import { themes } from "../../theme";

const TransferTicketsIcon = ({ children, color, ...props }) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
  >
    {children}
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        fill={color}
        {...color !== "currentColor" && { fillOpacity: ".65" }}
        fillRule="nonzero"
        d="M3.01698513,5.25119384 C2.3933853,4.70145646 2,3.89666826 2,3 C2,1.34314575 3.34314575,0 5,0 C6.65685425,0 8,1.34314575 8,3 C8,3.89643527 7.60681911,4.70103823 6.98350093,5.25076526 C8.73926022,5.86467842 10,7.53710878 10,9.5 L10,13.5 C10,13.7761424 9.77614237,14 9.5,14 L0.5,14 C0.223857625,14 -2.27373675e-13,13.7761424 -2.27373675e-13,13.5 L-2.27373675e-13,9.5 C-2.27373675e-13,7.53745723 1.26292965,5.86543384 3.01698513,5.25119384 Z M1,13 L9,13 L9,9.5 C9,7.56985763 7.43138226,6 5.5000567,6 L4.4999433,6 C2.57258184,6 1,7.57021309 1,9.5 L1,13 Z M5,5 C6.1045695,5 7,4.1045695 7,3 C7,1.8954305 6.1045695,1 5,1 C3.8954305,1 3,1.8954305 3,3 C3,4.1045695 3.8954305,5 5,5 Z M11.7046552,4.40349138 C11.5805665,4.31250785 11.5,4.16566259 11.5,4 C11.5,3.83433741 11.5805665,3.68749215 11.7046552,3.59650862 L15.7,0.6 C15.9209139,0.434314575 16.2343146,0.4790861 16.4,0.7 C16.5656854,0.9209139 16.5209139,1.23431458 16.3,1.4 L13.5,3.5 L15,3.5 C19.1421356,3.5 22.5,6.85786438 22.5,11 C22.5,11.2761424 22.2761424,11.5 22,11.5 C21.7238576,11.5 21.5,11.2761424 21.5,11 C21.5,7.41014913 18.5898509,4.5 15,4.5 L13.5,4.5 L16.3,6.6 C16.5209139,6.76568542 16.5656854,7.0790861 16.4,7.3 C16.2343146,7.5209139 15.9209139,7.56568542 15.7,7.4 L11.7046552,4.40349138 Z"
      />
      <g
        transform="translate(15.424621, 16.424621) rotate(45.000000) translate(-15.424621, -16.424621) translate(11.924621, 9.424621)"
        fill={color}
        {...color !== "currentColor" && { fillOpacity: ".65" }}
        fillRule="nonzero"
      >
        <path d="M6.5,5 L0.5,5 L0.5,13 L6.5,13 L6.5,5 Z M6.5,4 L6.5,1 L5.29894291,1 C4.91510153,1.61791491 4.2365719,2 3.5,2 C2.7634281,2 2.08489847,1.61791491 1.70105709,1 L0.5,1 L0.5,4 L6.5,4 Z M7,14 L0,14 C-0.276142375,14 -0.5,13.7761424 -0.5,13.5 L-0.5,0.5 C-0.5,0.223857625 -0.276142375,4.54747351e-13 0,4.54747351e-13 L2,4.54747351e-13 C2.18938603,4.54747351e-13 2.36251759,0.107001188 2.4472136,0.276393202 L2.5,0.381966011 C2.68938603,0.76073807 3.07651996,1 3.5,1 C3.92348004,1 4.31061397,0.76073807 4.5,0.381966011 L4.5527864,0.276393202 C4.63748241,0.107001188 4.81061397,4.54747351e-13 5,4.54747351e-13 L7,4.54747351e-13 C7.27614237,4.54747351e-13 7.5,0.223857625 7.5,0.5 L7.5,13.5 C7.5,13.7761424 7.27614237,14 7,14 Z" />
      </g>
    </g>
  </svg>
);

TransferTicketsIcon.displayName = "TransferTicketsIcon";

TransferTicketsIcon.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string
};

TransferTicketsIcon.defaultProps = {
  children: null,
  color: themes.global.gray01
};

export default TransferTicketsIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/TransferTickets.js